function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import subscriptions from 'js/services/payments/subscriptions';
import Header from 'js/containers/organisms/Header';
import Footer from 'js/containers/organisms/Footer';
import { standardMembershipPrice, premiumMembershipPrice } from 'json/factors';
import { PaypalButton } from '../../components/molecules/Button/Paypal';
import { Wrap, Container, PanelContainer, Panel, Title, FeatureList, Feature, Sentence, Price, SectionTitle } from './style';

var SearchPage =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SearchPage, _React$Component);

  function SearchPage(props) {
    var _this;

    _classCallCheck(this, SearchPage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchPage).call(this, props));

    _this.shouldComponentUpdate = function (nextProps, nextState) {
      if (_this.state.loading !== nextState.loading) return true;
      return false;
    };

    _this.createNormalSubscription = function () {
      _this.setState({
        loading: true
      });

      subscriptions.createNormalSubscriptions().then(function (res) {
        // eslint-disable-next-line no-console
        console.log(res); // here fix

        _this.setState({
          loading: false
        });

        window.location.href = res.url;
      }).catch(function (err) {
        // eslint-disable-next-line no-console
        console.log(err);

        _this.setState({
          loading: false
        });
      });
    };

    _this.createPremiumSubscription = function () {
      _this.setState({
        loading: true
      });

      subscriptions.createPremiumSubscriptions().then(function (res) {
        // eslint-disable-next-line no-console
        console.log(res);
        window.location.href = res.url;

        _this.setState({
          loading: false
        });
      }).catch(function (err) {
        // eslint-disable-next-line no-console
        console.log(err);

        _this.setState({
          loading: false
        });
      });
    };

    _this.state = {
      loading: false
    };
    return _this;
  }

  _createClass(SearchPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "render",
    value: function render() {
      this.props.actions.setBackground('transparent');
      this.props.actions.setColor('gray');

      if (!this.props.countries) {
        return null;
      }

      var _this$props = this.props,
          userRole = _this$props.userRole,
          active = _this$props.active,
          match = _this$props.match,
          institution_type = _this$props.institution_type,
          users_country = _this$props.users_country;
      var action = match.params.action;
      var standardPrice = standardMembershipPrice(users_country, institution_type);
      var premiumPrice = premiumMembershipPrice(users_country, institution_type);
      return React.createElement(Wrap, {
        id: "country-search-wrapper"
      }, React.createElement(Header, this.props), action ? React.createElement("div", null, React.createElement(SectionTitle, {
        red: true
      }, action === ':trial-expired' ? 'Your free trial has ended!' : action === ':standard-expired' ? 'Your standard plan has ended!' : action === ':premium-expired' ? 'Your premium plan has ended!' : ''), React.createElement(SectionTitle, null, "Choose plan now:")) : ['normalCustomer'].includes(userRole) && active ? React.createElement(SectionTitle, null, "Upgrade now!") : React.createElement(SectionTitle, null, "Choose plan now!"), React.createElement(Container, null, React.createElement(PanelContainer, null, ['freeTrialCustomer', 'normalCustomer', 'premiumCustomer'].includes(userRole) && !(['normalCustomer'].includes(userRole) && active) ? React.createElement(Panel, {
        loading: this.state.loading
      }, React.createElement(Title, null, "Standard"), React.createElement(Price, null, ' ', React.createElement("span", null, "$"), standardPrice), React.createElement(Sentence, null, "COSMOS Standard"), React.createElement(FeatureList, null, React.createElement(Feature, null, "Unlimited access to visualizations."), React.createElement(Feature, null, "Purchase data by time series.")), React.createElement(PaypalButton, {
        active: !this.state.loading,
        id: "#paypal-button1",
        handleClick: this.createNormalSubscription
      }, "PAGAR")) : '', ['freeTrialCustomer', 'normalCustomer', 'premiumCustomer'].includes(userRole) ? React.createElement(Panel, {
        loading: this.state.loading
      }, React.createElement(Title, null, "Premium"), React.createElement(Price, null, ' ', React.createElement("span", null, "$"), premiumPrice), React.createElement(Sentence, null, "COSMOS Premium"), React.createElement(FeatureList, null, React.createElement(Feature, null, "Unlimited access to visualizations."), React.createElement(Feature, null, React.createElement("b", null, "Unlimited downloads"), " at any time.")), React.createElement(PaypalButton, {
        active: !this.state.loading,
        id: "#paypal-button2",
        handleClick: this.createPremiumSubscription
      }, "PAGAR")) : '')), React.createElement(Footer, this.props));
    }
  }]);

  return SearchPage;
}(React.Component);

SearchPage.propTypes = {
  countries: PropTypes.func.isRequired,
  actions: PropTypes.object.isRequired,
  active: PropTypes.bool.isRequired,
  userRole: PropTypes.object.isRequired,
  history: PropTypes.array,
  isMobileWidth: PropTypes.bool.isRequired
};
export default withRouter(SearchPage);